export const JourneyAnalysisApiPath = {
  JOURNEY_ANALYSIS: '/api/sites/{site_id}/journey-analysis', // GET Journey Analysis
  JOURNEY_SUGGESTIONS: '/api/sites/{site_id}/journey-analysis/suggestions' // POST Journey Suggestions
}

export type JourneyAnalysisApiPath =
  (typeof JourneyAnalysisApiPath)[keyof typeof JourneyAnalysisApiPath]

export interface JourneyAnalysisVars {
  site_id: number
  days?: number
}

export interface JourneySuggestionsVars {
  site_id: number
  funnel: unknown[]
  top_paths: unknown[]
  exit_pages: unknown[]
  total_sessions?: number
  conversion_rate?: number
}

export interface JourneyAnalysisResponse {
  total_sessions: number
  total_visitors: number
  conversion_rate: number
  avg_actions_per_session: number
  funnel: unknown[]
  top_paths: unknown[]
  exit_pages: unknown[]
}

export interface JourneySuggestionsResponse {
  suggestions: string
}
